import { axiosWithAuth } from "../../helpers";

export const appEntryService = {
	createDraftApp,
	saveAppInProgress,
	submitApp,
	signApp,
};

const API_URL = process.env.REACT_APP_API_URL;

function createDraftApp() {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/create-draft-app`,
	};
	return axiosWithAuth(options);
}

function saveAppInProgress(application) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/save-app-in-progress`,
		data: application,
	};

	return axiosWithAuth(options);
}

function submitApp(draftApplication) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/submit-app`,
		data: draftApplication,
	};

	return axiosWithAuth(options);
}

function signApp({ applicationData, applicationId }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/sign_now/applications/${applicationId}/embedded_link`,
		data: { ...applicationData, applicationId },
	};

	return axiosWithAuth(options);
}
